import { Component, OnInit } from '@angular/core';
import { environment } from "../environments/environment";
import { FcmService } from './_services/fcm.svc';
import { AngularFireMessaging } from "@angular/fire/messaging";
import { DataService } from './_services';
import { fromEvent } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'appNG11';
  message:any = null;
  curUser: any;

  private messaging: firebase.default.messaging.Messaging;

  constructor(private fcmService: FcmService, private angularFireMessaging: AngularFireMessaging,
    private dataService: DataService ){

  }

  ngOnInit(): void {
    this.requestPermission();
    //this.listen();
    //this.receiveMessage();
    //this.fcmService.receiveMessage();

    this.curUser = this.getCurrentUser();

    //this.fcmService.requestToken(this.curUser.userId);

    // this.angularFireMessaging.tokenChanges.subscribe(token => {
    //   console.log('in tokenChanges event')
		// 	// this.dataService.saveToken(token,this.curUser.userId).subscribe(res => {
		// 	// 	if(res.status == "OK"){
				  
		// 	// 	}
		// 	// })
		// })

  }

  getCurrentUser(){
    var res = localStorage.getItem('currentUser');
    if(!res){
        return null;
    }
    let currentUser = JSON.parse(res);
    if (currentUser && currentUser.token) {
        return currentUser;
    }
    return null;
  }

    requestPermission() {
      this.angularFireMessaging.requestToken.subscribe(
        (token: any) => {
          //console.log(token);
          
        },
        (err: any) => {
          console.error('Unable to get permission to notify.', err);
        }
      );
    }
    
    receiveMessage() {
       
      this.angularFireMessaging.messages.subscribe(
        (payload: any) => {
          console.log("new message received. ", payload);
          if(payload != null){
            //this.message = payload;
            const NotificationTitle = payload.notification.title;
            const NotificationOptions = {
              body: payload.notification.body,
              data: payload.data,
              icon: payload.notification.icon
            }           

          }
        })
        // this.angularFireMessaging.onMessage(payload => {
        //     this.message = payload;
        //   });
        // this.angularFireMessaging.onBackgroundMessage(payload => {
        //   this.message = payload;
        // });
    }
  }
    

    // const messaging = getMessaging();
    // getToken(messaging, 
    //  { vapidKey: environment.firebase.vapidKey}).then(
    //    (currentToken) => {
    //      if (currentToken) {
    //        console.log("Hurraaa!!! we got the token.....");
    //        console.log(currentToken);
    //      } else {
    //        console.log('No registration token available. Request permission to generate one.');
    //      }
    //  }).catch((err) => {
    //     console.log('An error occurred while retrieving token. ', err);
    // });
  //}
  // listen() {
  //   const messaging = getMessaging();
  //   onMessage(messaging, (payload) => {
  //     console.log('Message received. ', payload);
  //     this.message=payload;
  //   });
  // }
//}
